import React from "react";
import { Divider, Flex, Text } from "@chakra-ui/react";
import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import PathPickLandingSection from "@/features/pathpick/features/landing/components/PathPickLandingSection";
import {
  PATHPICK_LANDING_COLORS,
  PROBLEM_ITEM_KEYS,
} from "@/features/pathpick/features/landing/constants";

// 소싱 과정에서 겪는 문제 나열 — 번호(01~04)와 문장 한 줄이 전부다.
function PathPickLandingProblemSection() {
  const { t, Trans } = useI18nHelper();

  return (
    <PathPickLandingSection
      title={
        <Trans
          i18nKey={"path_pick_landing:problem.title"}
          components={{
            b: <Text as={"span"} color={PATHPICK_LANDING_COLORS.blue} />,
          }}
        />
      }
    >
      <Flex flexDirection={"column"}>
        {PROBLEM_ITEM_KEYS.map((key, index) => (
          <React.Fragment key={key}>
            <Divider borderColor={PATHPICK_LANDING_COLORS.divider} />
            <Flex
              gap={{ base: "16px", lg: "48px" }}
              alignItems={"center"}
              paddingY={{ base: "18px", lg: "22px" }}
            >
              <Text
                textStyle={"body-sm-bold"}
                color={PATHPICK_LANDING_COLORS.amber}
                flexShrink={0}
                width={"24px"}
              >
                {String(index + 1).padStart(2, "0")}
              </Text>
              <Text
                textStyle={"body-md-bold"}
                fontSize={{ base: "15px", lg: "17px" }}
                color={PATHPICK_LANDING_COLORS.textStrong}
              >
                {t(`path_pick_landing:problem.items.${key}`)}
              </Text>
            </Flex>
          </React.Fragment>
        ))}
        <Divider borderColor={PATHPICK_LANDING_COLORS.divider} />
      </Flex>
    </PathPickLandingSection>
  );
}

export default PathPickLandingProblemSection;
